import React from 'react';
import { Destination } from '../../types/Destination';

type DestinationListProps = {
  destinations: Destination[];
  searchValue: string;
  searchError: string;
  searchResult: Destination | null;
  loading: boolean;
  onSearchChange: (value: string) => void;
  onView: (destination: Destination) => void;
  onEdit: (destination: Destination) => void;
  onDelete: (slug: string, title: string) => void;
};

const DestinationList: React.FC<DestinationListProps> = ({
  destinations,
  searchValue,
  searchError,
  searchResult,
  loading,
  onSearchChange,
  onView,
  onEdit,
  onDelete
}) => (
  <section className="destinations-list-section">
    <div
      className="list-header"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap'
      }}
    >
      <h2>All Destinations</h2>
      <input
        type="text"
        placeholder="Search by title or slug..."
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{
          width: '220px',
          maxWidth: '100%',
          padding: '8px 10px',
          fontSize: '14px',
          border: '1px solid #ddd',
          borderRadius: '4px'
        }}
      />
    </div>

    {searchError && <div style={{ marginTop: '8px', color: '#c0392b', fontSize: '14px' }}>{searchError}</div>}

    {searchResult ? (
      <div className="destinations-list">
        <article className="destination-card" key={`search-${searchResult.slug}`}>
          <div className="destination-card-header">
            <div>
              <h3>{searchResult.title}</h3>
              <p>{searchResult.slug}</p>
            </div>
            <div className="destination-actions">
              <button type="button" className="pill-btn" onClick={() => onView(searchResult)}>
                View
              </button>
              <button type="button" className="pill-btn" onClick={() => onEdit(searchResult)}>
                Edit
              </button>
              <button type="button" className="pill-btn danger" onClick={() => onDelete(searchResult.slug, searchResult.title)}>
                Delete
              </button>
            </div>
          </div>

          <div className="destination-card-body">
            <img src={searchResult.hero.image.src} alt={searchResult.hero.image.alt} />
            <div>
              <p>{searchResult.summary}</p>
              <div className="destination-meta">
                <span>{searchResult.countryOrRegion || '—'}</span>
                <span>{searchResult.bestTimeToVisit || '—'}</span>
              </div>
            </div>
          </div>
        </article>
      </div>
    ) : (
      <div className="destinations-list">
        {loading && <div className="loading">Loading destinations...</div>}
        {!loading && !destinations.length && <div className="no-data">No destinations found.</div>}

        {destinations.map((destination, idx) => (
          <article className="destination-card" key={`${destination.slug}-${idx}`}>
            <div className="destination-card-header">
              <div>
                <h3>{destination.title}</h3>
                <p>{destination.slug}</p>
              </div>
              <div className="destination-actions">
                <button type="button" className="pill-btn" onClick={() => onView(destination)}>
                  View
                </button>
                <button type="button" className="pill-btn" onClick={() => onEdit(destination)}>
                  Edit
                </button>
                <button type="button" className="pill-btn danger" onClick={() => onDelete(destination.slug, destination.title)}>
                  Delete
                </button>
              </div>
            </div>

            <div className="destination-card-body">
              <img src={destination.hero.image.src} alt={destination.hero.image.alt} />
              <div>
                <p>{destination.summary}</p>
                <div className="destination-meta">
                  <span>{destination.countryOrRegion || '—'}</span>
                  <span>{destination.bestTimeToVisit || '—'}</span>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    )}
  </section>
);

export default DestinationList;
